module.exports = __webpack_public_path__ + "img/progress-circle-master.85c81210.svg";